export const AppliedMultiFilterDisplay = ({ parentKey, filters, onCloseClick, onRemoveItem, onTextClick, isResettable = false }) => {
    return (
        <>

            <div className="badge badge-primary d-flex align-items-center text-white p-0">

                <div className="btn-group">
                    <button className="btn btn-none btn-sm py-1 m-0 d-flex align-items-center px-2 text-white dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        { parentKey }: {filters.length} selected
                    </button>
                    <button onClick={ () => onCloseClick(parentKey) } type="button" className="btn btn-none btn-sm m-0 p-0 py-2 px-2 border-left"><i className={ `fas ${ isResettable ? "fa-undo" : "fa-times" } text-white m-0 p-0` }></i></button>
                    <div className="dropdown-menu">
                        {
                            filters.map(
                                filter => <div key={ filter.id } className="dropdown-item badge badge-light d-flex align-items-center text-white p-0 justify-content-between mb-1">
                                    <button type="button" onClick={ () => {
                                        if (onTextClick) {
                                            onTextClick(parentKey)
                                        }
                                    } } className="btn btn-none btn-sm m-0 d-flex align-items-center px-2">
                                        { filter.label }
                                    </button>
                                    <button onClick={ event => {
                                        event.stopPropagation()
                                        onRemoveItem(filter.id)
                                    } } type="button" className="btn btn-none btn-sm m-0 p-0 py-2 px-2"><i className={ `fas ${ isResettable ? "fa-undo" : "fa-times" } m-0 p-0` }></i></button>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </>
    )
}